import type { RailwaySession } from '@cli-types/next-adapter/railway.js'
import { outputTail } from '@cli-utils/process.js'
import { parseRailwayJson } from '@next-adapter/init/railway/runner/parse-railway-json.js'
import { runRailway } from '@next-adapter/init/railway/runner/run-railway.js'

export async function readRailwayServiceVariables(
  session: RailwaySession,
  cwd: string,
  service: string
): Promise<Record<string, string>> {
  const result = await runRailway(
    session.runner,
    [
      'variable',
      'list',
      '--service',
      service,
      '--environment',
      session.project.environmentName,
      '--json'
    ],
    { cwd, mode: 'capture', env: session.env }
  )
  if (!result.success) {
    throw new Error(
      outputTail(`${result.stdout}\n${result.stderr}`) ??
        `Could not read Railway variables for ${service}.`
    )
  }

  const payload = parseRailwayJson<unknown>(result.stdout)
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    throw new Error(`Railway returned an invalid variable list response for ${service}.`)
  }

  const entries = Object.entries(payload)
  if (entries.some(([, value]) => typeof value !== 'string')) {
    throw new Error(`Railway returned an invalid variable list response for ${service}.`)
  }

  return Object.fromEntries(entries) as Record<string, string>
}
